<template>
  <Record :title="user | name">
    <Row>
      <Column :xs="6">
        <Set icon="mail" :label="$t('email')">
          {{ user.email }}
        </Set>
      </Column>
      <Column :xs="6">
        <Set :icon="signupType || 'mail'" :label="$t('type')">
          {{ (signupType || 'Email') | capitalizeFirst }}
        </Set>
      </Column>
      <Column :xs="6">
        <Set icon="lock" :label="$t('role')">
          {{ getRole(user.role).label }}
        </Set>
      </Column>
      <Column :xs="6">
        <Set icon="clock" :label="$t('date')">
          {{ $d(user.createdAt, 'short') }}
        </Set>
      </Column>
    </Row>
    <RecordActions
      slot="actions"
      :doShowDelete="hasRole('>=ADMIN')"
      name="user"
      :record="user"
      routeName="User" />
  </Record>
</template>

<script>
import Record from '@components/Record'
import RecordActions from '@components/RecordActions'
import Set from '@components/Set'
import { getters } from '@utils'

export default {
  components: { Record, RecordActions, Set },
  props: {
    user: Object,
  },
  computed: {
    signupType() {
      if (this.user.facebookId) return 'facebook'
      if (this.user.googleId) return 'google'
      return null
    },
    ...getters('getRole'),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "country": "Country",
    "date": "Registration date",
    "email": "Email",
    "role": "Role",
    "type": "Registration type"
  }
}
</i18n>
